export const RUNNING = "RUNNING";
export const STOPPED = "STOPPED";
export const BUSY = "BUSY";